import React from 'react'
import Link from 'gatsby-link'

import github from '../img/github-icon.svg'
import logo from '../img/logo.svg'

const Navbar = () => (
  <nav className="navbar navbar-expand-md navbar-light bg-white absolute-top">
    <div className="container">

      <button className="navbar-toggler order-2 order-md-1" type="button" data-toggle="collapse" data-target="#navbar"
              aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse order-3 order-md-2" id="navbar">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item dropdown active">
            <a className="nav-link dropdown-toggle" href="#" id="dropdown02" data-toggle="dropdown"
               aria-haspopup="true" aria-expanded="false">Home</a>
            <div className="dropdown-menu" aria-labelledby="dropdown02">
              <a className="dropdown-item" href="home-onecolumn.html">One column</a>
              <a className="dropdown-item" href="home-twocolumn.html">Two column</a>
              <a className="dropdown-item" href="home-threecolumn.html">Three column</a>
              <a className="dropdown-item" href="home-fourcolumn.html">Four column</a>
              <a className="dropdown-item" href="home-featured.html">Featured posts</a>
              <a className="dropdown-item" href="home-fullwidth.html">Full width</a>
            </div>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="dropdown02" data-toggle="dropdown"
               aria-haspopup="true" aria-expanded="false">Posts</a>
            <div className="dropdown-menu" aria-labelledby="dropdown02">
              <a className="dropdown-item" href="post-image.html">Image</a>
              <a className="dropdown-item" href="post-video.html">Video</a>
              <a className="dropdown-item" href="post-new.html">New story</a>
            </div>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="dropdown03" data-toggle="dropdown"
               aria-haspopup="true" aria-expanded="false">Components</a>
            <div className="dropdown-menu" aria-labelledby="dropdown03">
              <a className="dropdown-item" href="doc-typography.html">Typography</a>
              <a className="dropdown-item" href="doc-buttons.html">Buttons</a>
              <a className="dropdown-item" href="doc-tables.html">Tables</a>
              <a className="dropdown-item" href="doc-forms.html">Forms</a>
              <a className="dropdown-item" href="doc-cards.html">Cards</a>
            </div>
          </li>
        </ul>
      </div>

      <Link to="/" className="navbar-brand mx-auto order-1 order-md-3">
        <figure className="image">
          <img src={logo} alt="ketostrive" style={{ width: '200px' }} />
        </figure>
      </Link>

      <div className="collapse navbar-collapse order-4 order-md-4" id="navbar">
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <a className="nav-link" href="page-about.html">About</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="page-contact.html">Contact</a>
          </li>
        </ul>
        <form className="form-inline" role="search">
          <input className="search js-search form-control form-control-rounded mr-sm-2" type="text"
                 title="Enter search query here.." placeholder="Search.." aria-label="Search" />
        </form>
      </div>
    </div>
  </nav>
)

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar.js